import { render, staticRenderFns } from "./PickUp.vue?vue&type=template&id=d9dff7f4&scoped=true&"
import script from "./PickUp.vue?vue&type=script&lang=js&"
export * from "./PickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9dff7f4",
  null
  
)

export default component.exports